/**
 * Legacy Contentful schema for Search Page content model
 * to be removed once https://aviosgroup.atlassian.net/browse/RPS-14800 is completed for all products
 */
import { z } from 'zod'
import { ContentfulAssetSchema, ContentfulBynderImageSchema } from './asset'
import { ContentfulRichTextDocumentSchema } from './common'
import { ContentfulHeroSchema } from './hero'

export const ContentfulSearchContentProductSchema = z.enum([
  'flights',
  'hotels',
  'carhire',
  'experiences',
])

export type ContentfulSearchContentProduct = z.infer<typeof ContentfulSearchContentProductSchema>

export const ContentfulCardLegacySchema = z.object({
  image: ContentfulAssetSchema,
  bynderImage: z.array(ContentfulBynderImageSchema).optional(),
  heading: z.string().optional(),
  subHeading: z.string().optional(),
  caption: z.string().optional(),
  link: z.string().optional(),
  destinationAirport: z.string().length(3).optional(),
  avios: z.number().optional(),
})

export type ContentfulCardLegacy = z.infer<typeof ContentfulCardLegacySchema>

export const ContentfulIntroSectionSchema = z.object({
  identifier: z.string().optional(),
  content: ContentfulRichTextDocumentSchema,
  cards: z
    .array(ContentfulCardLegacySchema.nullable())
    .transform((arr) => arr.filter((item): item is ContentfulCardLegacy => item !== null))
    .optional(),
})

export type ContentfulIntroSection = z.infer<typeof ContentfulIntroSectionSchema>

export const ContentfulSearchContentSchema = z.object({
  name: z.string(),
  identifier: z.string(),
  entryId: z.string().optional(),
  revisionId: z.number().optional(),
  productLabel: z.string().optional(),
  product: ContentfulSearchContentProductSchema.optional(),
  hero: ContentfulHeroSchema.optional(),
  trendingDestinations: z
    .array(ContentfulCardLegacySchema.nullable())
    .transform((arr) => arr.filter((item): item is ContentfulCardLegacy => item !== null))
    .optional(),
  intro: ContentfulIntroSectionSchema.optional(),
  recommended: ContentfulIntroSectionSchema.optional(),
  fallbackLink: z.string().optional(),
})

export type ContentfulSearchContent = z.infer<typeof ContentfulSearchContentSchema>

export const ContentfulSearchPageSchema = z.object({
  name: z.string(),
  identifier: z.string(),
  products: z
    .array(ContentfulSearchContentSchema.nullable())
    .transform((arr) => arr.filter((item): item is ContentfulSearchContent => item !== null)),
})

export type ContentfulSearchPage = z.infer<typeof ContentfulSearchPageSchema>
